import React from 'react';

import { DangerText } from '../common/Text/DangerText';
import SesamToggleSwitch from '../common/SesamToggleSwitch';

import { TestID } from '../../testID';

import type { OnToggleEvent } from '../../types/common.types';

export const MenuToggleButton: React.FC<{
  isOn?: boolean;
  isDangerText?: boolean;
  text: string;
  title: string;
  wrapperStyle?: React.CSSProperties;
  toggleButtonStyle?: React.CSSProperties;
  testId?: string;
  onToggle: (checked: boolean) => void;
}> = ({
  isOn,
  isDangerText = false,
  text,
  title,
  onToggle,
  wrapperStyle,
  toggleButtonStyle,
  testId,
}) => (
  <div
    style={{
      marginLeft: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      ...wrapperStyle,
    }}
    title={title}
  >
    {isDangerText ? <DangerText style={{ display: 'inline' }}>{text}</DangerText> : text}
    {/* @ts-ignore */}
    <SesamToggleSwitch
      isOn={isOn}
      leftLabel=""
      rightLabel=""
      onToggle={(e: OnToggleEvent) => onToggle(e.target.checked)}
      style={{ right: '5px', float: 'right', marginBottom: -4, ...toggleButtonStyle }}
      testId={testId}
    />
  </div>
);
